module.exports = __webpack_public_path__ + "img/sol_3.2719faed.jpg";